















































import Vue from 'vue'
import moment from 'moment'
import {
  CALENDAR_EVENT_ASSISTANT_GET_IS_EDITING_SERIE,
  CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY, CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  CALENDAR_EVENT_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST,
  GET_SELECTED_UI_LANGUAGE
} from '@/store/getter-types'
import {
  CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  CALENDAR_EVENT_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST,
} from '@/store/action-types'
import _ from 'lodash'
import { PlanningAssistantPeriodicityPayload } from '@/types/payload'
import { PeriodicityPlannedCalendarEventEmployee } from '@/types'
import { CalendarEventEmployee } from '@/model/calendarEvent/CalendarEventEmployee'

interface EditableEmployee {
  id: number | undefined
  name: string | undefined
  comment: string
  detailId?: number
}

interface ComponentData {
  comment: string
  editableEmployeeList: EditableEmployee[] | any
  panel: number[]
}

export default Vue.extend({
  name: 'CalendarEventEditorAdditionalInformation',

  data (): ComponentData {
    return {
      comment: '',
      editableEmployeeList: [],
      panel: [0]
    }
  },

  props: {
    editAdditionalInformation: Boolean
  },

  computed: {
    plannedEmployeeList (): CalendarEventEmployee[] {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
    },

    plannedEditableEmployeeList (): Array<EditableEmployee> {
      const temporaryEmployees: Array<EditableEmployee> = []

      this.plannedEmployeeList.forEach((employee: CalendarEventEmployee) => {
        let isEmployeeCreated = false

        if (!isEmployeeCreated) {
          const editableEmployee: EditableEmployee = {
            id: employee.id,
            name: employee.name,
            comment: employee.comment,
          }
          temporaryEmployees.push(editableEmployee)
        }
      })
      this.editableEmployeeList = []
      this.editableEmployeeList = _.cloneDeep(temporaryEmployees)
      return this.editableEmployeeList
    },

    periodicityPlannedEmployeeList (): PeriodicityPlannedCalendarEventEmployee[] {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
    },

    periodicityPlannedEditableEmployeeList (): PeriodicityPlannedCalendarEventEmployee[] {
      this.editableEmployeeList = []
      this.editableEmployeeList = _.cloneDeep(this.periodicityPlannedEmployeeList.map((item: PeriodicityPlannedCalendarEventEmployee) => {

        const temporaryEmployees: EditableEmployee[] = []
        let isEmployeeCreated = false

        if (!isEmployeeCreated) {
          item.employeeList.forEach((employee: CalendarEventEmployee) => {
            const editableEmployee: EditableEmployee = {
              id: employee.id,
              name: employee.name,
              comment: employee.comment,
              detailId: employee.detailId
            }
            temporaryEmployees.push(editableEmployee)
          })
        }

        return { date: item.date, employeeList: temporaryEmployees }
      }))

      return this.editableEmployeeList
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    periodicity (): PlanningAssistantPeriodicityPayload {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY]
    },

    isEditingSerie (): boolean {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_IS_EDITING_SERIE]
    },
  },

  watch: {
    editAdditionalInformation (newVal: boolean): void {
      if(newVal) {
        setTimeout(() => {
          const focusedField: any = document.getElementById('focusedField1')
          if (focusedField) {
            focusedField.focus()
          }

          this.$emit('changeEditAdditionalInformation')
        }, 0)
      }
    }
  },

  methods: {
    onKeyDown (event: any): void {
      if(event.code === 'Tab' && !event.shiftKey && this.plannedEditableEmployeeList.length > 0 &&  event.target && event.target.id === `focusedField${this.plannedEditableEmployeeList.length}`) {
        this.$emit('goToNextStep')
      } else if(event.code === 'ArrowUp' && !event.shiftKey) {
        this.$emit('goToNextStep')
      }
    },

    formattedDate (date: string): string {
      return moment(date, 'DD.MM.YYYY').locale(this.selectedLocale).format('DD.MM.YYYY - dddd')
    },

    formatDate (date: Date): string {
      if(date) {
        return moment(date).format('DD.MM.YYYY')
      } else {
        return ''
      }
    },

    formatDateIso (date: Date): string {
      return moment(date).format('YYYY-MM-DD')
    },

    onCommentChange (employee: EditableEmployee): void {
      this.updateEmployeeComment(employee, false)
    },

    onCommentClear (employee: EditableEmployee): void {
      this.updateEmployeeComment(employee, true)
    },

    updateEmployeeComment (employee: EditableEmployee, isClearNoteEvent: boolean): void {
      let employeeIndex: number = -1

      const localPlannedEmployeeList = _.cloneDeep(this.plannedEmployeeList)
      employeeIndex = _.findIndex(localPlannedEmployeeList, { id: employee.id })
      let updatedPlannedEmployee = localPlannedEmployeeList[employeeIndex!].updateComment(isClearNoteEvent ? '' : employee.comment)

      if (employeeIndex !== -1) {
        localPlannedEmployeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    },

    onCommentChangePeriodicity (employee: EditableEmployee, idx: number): void {
      this.updateEmployeeCommentPeriodicity(employee, idx, false)
    },

    onCommentClearPeriodicity (employee: EditableEmployee, idx: number): void {
      this.updateEmployeeCommentPeriodicity(employee, idx, true)
    },

    updateEmployeeCommentPeriodicity (employee: EditableEmployee, idx: number, isClearNoteEvent: boolean): void {
      let employeeIndex: number = -1

      const localPlannedEmployeeList = _.cloneDeep(this.periodicityPlannedEmployeeList)
      employeeIndex = _.findIndex(localPlannedEmployeeList[idx].employeeList, { id: employee.id })
      let updatedPlannedEmployee = localPlannedEmployeeList[idx].employeeList[employeeIndex!].updateComment(isClearNoteEvent ? '' : employee.comment)

      if (employeeIndex !== -1) {
        localPlannedEmployeeList[idx].employeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    }
  }

})
